import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { defaultTheme } from '../../theme/defaultTheme';
import CartDrawer from './CartDrawer';
import ConfirmReplaceCartModal from './ConfirmReplaceCartModal';
import { useGuestCartStore } from '../store/useGuestCartStore';

/**
 * Mount once at app-shell level.
 * - Toasts
 * - Cart drawer UI (opened from header or add-to-cart)
 * - Replace-cart confirmation modal (single-restaurant rule)
 * - Cross-tab sync (storage event)
 */
export default function GuestCartRoot() {
  useEffect(() => {
    const onStorage = (e) => {
      if (!e?.key) return;
      // Zustand persist handles rehydration on refresh; this keeps multiple tabs consistent.
      if (e.key.includes('dindin.guestCart.v1')) {
        // force rehydrate by reading persisted state (zustand persist doesn't auto-listen)
        try {
          const storage = window.localStorage.getItem(e.key);
          if (!storage) return;
          const parsed = JSON.parse(storage);
          const state = parsed?.state;
          if (state && typeof state === 'object') {
            useGuestCartStore.setState((s) => ({
              ...s,
              ...state,
              ui: s.ui, // don't stomp UI state across tabs
              inFlight: s.inFlight,
            }));
          }
        } catch {
          // ignore
        }
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <>
      <Toaster
        position="top-center"
        gutter={10}
        containerStyle={{ top: 72 }}
        toastOptions={{
          duration: 2600,
          className: 'dindin-toast',
          style: {
            fontFamily: defaultTheme.typography.fontBase,
            background: defaultTheme.colors.primary,
            color: defaultTheme.colors.background,
            borderRadius: '12px',
            padding: '14px 18px',
            fontSize: '15px',
            fontWeight: 600,
            boxShadow: '0 12px 32px rgba(43, 58, 91, 0.38)',
            maxWidth: 'min(420px, calc(100vw - 32px))',
            border: '1px solid rgba(255, 255, 255, 0.12)',
          },
          success: {
            duration: 2400,
            style: {
              fontFamily: defaultTheme.typography.fontBase,
              background: defaultTheme.colors.primary,
              color: defaultTheme.colors.background,
              borderRadius: '12px',
              padding: '14px 18px',
              fontSize: '15px',
              fontWeight: 600,
              boxShadow: '0 12px 32px rgba(43, 58, 91, 0.38)',
              maxWidth: 'min(420px, calc(100vw - 32px))',
              border: `2px solid ${defaultTheme.colors.accent}`,
            },
            iconTheme: { primary: defaultTheme.colors.accent, secondary: defaultTheme.colors.background },
          },
          error: {
            duration: 4000,
            style: {
              fontFamily: defaultTheme.typography.fontBase,
              background: defaultTheme.colors.primary,
              color: defaultTheme.colors.background,
              borderRadius: '12px',
              padding: '14px 18px',
              fontSize: '15px',
              fontWeight: 600,
              boxShadow: '0 12px 32px rgba(43, 58, 91, 0.38)',
              maxWidth: 'min(420px, calc(100vw - 32px))',
              border: `2px solid ${defaultTheme.colors.accent}`,
            },
            iconTheme: { primary: defaultTheme.colors.background, secondary: defaultTheme.colors.accent },
          },
        }}
      />
      <ConfirmReplaceCartModal />
      <CartDrawer />
    </>
  );
}

